import { useState, useEffect } from 'react';
import { getOfflineSession } from '../offlineDb';

export function useOfflineSession() {
  const [session, setSession] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const s = await getOfflineSession();
        if (!cancelled) {
          setSession(s || null);
          setIsLoading(false);
        }
      } catch {
        if (!cancelled) {
          setSession(null);
          setIsLoading(false);
        }
      }
    };

    load();

    // Re-check when session might have changed
    const onSessionChanged = () => load();
    window.addEventListener('offlineSessionChanged', onSessionChanged);

    return () => {
      cancelled = true;
      window.removeEventListener('offlineSessionChanged', onSessionChanged);
    };
  }, []);

  return { session, hasSession: !!session, isLoading };
}
